
import { useEffect } from 'react'
import Select from 'react-select'
import { EnergyStatusDDLAPI, MachineryDetailsDDLAPI, UnitTypeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPMachineryDetailsDDL = (props) => {
    const { MachineryDetails, setMachineryDetails, rowData, Flag, MachEquipmentType, WardName } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            M_STP_MachEquipmentTypeID: MachEquipmentType.ID,
            M_UserID: UserID,
            token: token,
            Flag: Flag,
        }
        if(MachEquipmentType.ID !== 0){
            dispatch(MachineryDetailsDDLAPI({ data }))
        }
    }, [WardName.ID, MachEquipmentType.ID])

    const { MachineryDetailsData } = useSelector(state => state.MachineryDetailsDDL)

    useEffect(() => {
        handleSTPMachineryDetailsDDL()
    }, [MachineryDetailsData])

    const handleSTPMachineryDetailsDDL = () => {
        // console.log(DeptDDLDataa)
        if (MachineryDetailsData && MachineryDetailsData.table && MachineryDetailsData.table.length > 0) {
            let list = MachineryDetailsData.table.map((item, index) => ({
                value: item.m_stP_MachineryDetailsID,
                label: item.machineryDetails,
            }))
            // setMachineryDetails({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_stP_MachineryDetailsID : 0,
            //     Label: Flag === 'Update' ? rowData.machineryDetails : "Select...",
            // })
            setMachineryDetails({ ...MachineryDetails, DDL: list })
        }
        else {
            setMachineryDetails({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Machinery Details </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: MachineryDetails.ID, label: MachineryDetails.Label }}
                onChange={(e) => {
                    e ?
                        setMachineryDetails({ ...MachineryDetails, ID: e.value, Label: e.label })
                        :
                        setMachineryDetails({ ...MachineryDetails, ID: 0, Label: "Select..." })

                }}
                options={MachineryDetails.DDL}
            />
        </div>
    )
}